import React from "react";
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Banner, Details } from "./components";
import { useParams } from "react-router";
import { departmentinternal } from "views/EyeCareDetails/internal-data";
import { Testimonial } from "components";
import { list as allList } from "views/EyeCareDetails/internal-data/doctors";
import { BookAppointmentStrip } from "components";
import { Helmet } from "react-helmet-async";

const EyeCareInternal = ({ doctorView }) => {
  const { id, departId } = useParams();
  const departmentContent =
    departmentinternal[departId] || departmentinternal.opthomology || {};
  const { internalData, list, listheader } = departmentContent;

  const normalizedId = String(id || "").trim();
  const pageData =
    internalData?.find(
      (item) =>
        item.id?.toLowerCase() === normalizedId.toLowerCase() ||
        item.id === normalizedId
    ) ||
    internalData?.find((item) => item.id === normalizedId) ||
    {};
  const faqsSection = pageData?.faqsSection;
  const pageSchema =
    pageData?.faqSchema &&
    pageData.faqSchema?.mainEntity?.length
      ? pageData.faqSchema
      : null;

  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // Split the label using "||"
  const [rawLabel1, rawLabel2] = pageData?.label?.split("||") || [];
  const label1 = rawLabel1?.trim();
  const label2 = rawLabel2?.trim();

  return (
    <Box>
      <Helmet>
        <title>{pageData?.title}</title>
        <meta name="description" content={pageData?.description || "No Description "} />
        <meta name="keywords" content={pageData?.keyword} />
        <meta name="title" content={pageData?.title} />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageData?.url} />
        <meta property="og:title" content={pageData?.title} />
        <meta property="og:description" content={pageData?.description || "No Description"} />
        <meta property="og:image" content={pageData?.Imageme} />

        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={pageData?.url} />
        <meta property="twitter:title" content={pageData?.title} />
        <meta property="twitter:description" content={pageData?.description || "No Description"} />
        <meta property="twitter:image" content={pageData?.Imageme} />

        {pageSchema && (
          <script type="application/ld+json">
            {JSON.stringify(pageSchema)}
          </script>
        )}
      </Helmet>

      <Box position={"relative"}>
        <Banner text={pageData.label} bannerImg={pageData?.banner} />

        {Boolean(pageData?.label) && (
          <Box
            position="absolute"
            sx={{
              top: "50%",
              transform: "translateY(-50%)",
              left: { md: "5rem", xs: "1rem" },
            }}
          >
            {label1 && (
              <Typography
                fontSize={{ md: "2.125rem", xs: "2.25rem" }}
                fontWeight={600}
                component="h1"
              >
                {label1}
              </Typography>
            )}

            {label2 && (
              <Typography
                component="p"
                fontSize={{ md: "1.5rem", xs: "1.25rem" }}
                fontWeight={400}
              >
                {label2}
              </Typography>
            )}
          </Box>
        )}
      </Box>

      <Box mb={{ md: "10rem", xs: "2.5rem" }}>
        <BookAppointmentStrip />
      </Box>

      <Details
        data={pageData.data}
        doctorView={doctorView}
        links={departId === "general" ? allList : list}
        departId={departId}
        img={pageData.img}
        listheader={listheader}
      />

      <Testimonial />
      {faqsSection && (
        <Box py={5}>
          <Typography
            fontSize={{ md: "2.5rem", xs: "2rem" }}
            fontWeight="bold"
            textAlign="center"
            component="h2"
          >
            {faqsSection.heading}
          </Typography>
          <Box mt={3} px={{ md: 8, xs: 3 }}>
            {faqsSection.services.map((service, idx) => {
              const panelId = `panel${idx + 1}`;
              const isExpanded = expanded === panelId;

              return (
                <Accordion
                  key={service.id || panelId}
                  expanded={isExpanded}
                  onChange={handleChange(panelId)}
                  elevation={0}
                  sx={{
                    boxShadow: "0 6px 18px rgba(19,22,24,0.04)",
                    borderRadius: "10px",
                    mb: 2.5,
                    "&:before": {
                      display: "none",
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#2EAD9F" }} />}
                    aria-controls={`${panelId}-content`}
                    id={`${panelId}-header`}
                    sx={{
                      minHeight: 64,
                      "& .MuiAccordionSummary-content": {
                        margin: 0,
                        alignItems: "center",
                      },
                      px: { md: 4, xs: 3 },
                      py: { md: 1.5, xs: 1 },
                      ...(isExpanded && {
                        backgroundColor: "#BEEDE6",
                        borderTopLeftRadius: "10px",
                        borderTopRightRadius: "10px",
                      }),
                    }}
                  >
                    <Typography sx={{ fontWeight: 700 }}>
                      {service.label}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      px: { md: 4, xs: 3 },
                      pt: 2.5,
                      pb: 3,
                      borderBottomLeftRadius: "10px",
                      borderBottomRightRadius: "10px",
                    }}
                  >
                    <Typography sx={{ color: "#5f6468", lineHeight: 1.8 }}>
                      {service.content}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default EyeCareInternal;
